import React from 'react'
import { node, string, bool, obj } from 'prop-types'
import ConfigConsumer from '../../redux/configuration/context'
import SvgIcon from '../SvgIcon/SvgIcon'
import './PageWarningBanner.scss'

const PageWarningBanner = ({ children, centered, message, style }) => (
  <div
    style={style ?? {}}
    className={`page-warning-banner ${centered ? 'centered' : ''}`}
  >
    <ConfigConsumer>
      {({ themeVariables }) => (
        <SvgIcon type="warning" fill={themeVariables.themeIconColor} />
      )}
    </ConfigConsumer>
    <span className="page-warning-content">{children}</span>
  </div>
)

PageWarningBanner.defaultProps = {
  centered: false,
  style: {}
}

PageWarningBanner.propTypes = {
  /**
   * The required warning message string for the alt text
   */
  message: string,
  /**
   * The required warning message node, used to include links
   */
  children: node,
  centered: bool,
  style: obj
}

export default PageWarningBanner
